var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "pb-0",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c("gg-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              label: "Key Name",
              name: "Key Name",
              "error-messages": _vm.errors.collect("Key Name")
            },
            model: {
              value: _vm.keyData.name,
              callback: function callback($$v) {
                _vm.$set(_vm.keyData, "name", $$v)
              },
              expression: "keyData.name"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pb-0",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c(
            "gg-input-label",
            {
              attrs: {
                for: "ppk-pass"
              }
            },
            [_vm._v("Password")]
          ),
          _c("compact-password", {
            attrs: {
              outlined: "",
              id: "ppk-pass",
              "show-strength": "",
              "cpanel-app": "sshkey",
              "with-generator": "",
              "data-vv-name": "password",
              "data-vv-as": "Password",
              "error-messages": _vm.errors.collect("password")
            },
            model: {
              value: _vm.keyData.pass,
              callback: function callback($$v) {
                _vm.$set(_vm.keyData, "pass", $$v)
              },
              expression: "keyData.pass"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "py-0",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c("gg-select", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              items: _vm.availableTypes,
              label: "Key Type",
              name: "Key Type",
              "error-messages": _vm.errors.collect("Key Type")
            },
            model: {
              value: _vm.keyData.type,
              callback: function callback($$v) {
                _vm.$set(_vm.keyData, "type", $$v)
              },
              expression: "keyData.type"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "py-0",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c("gg-select", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              items: _vm.availableBits,
              label: "Key Size",
              name: "Key Size",
              "error-messages": _vm.errors.collect("Key Size")
            },
            model: {
              value: _vm.keyData.bits,
              callback: function callback($$v) {
                _vm.$set(_vm.keyData, "bits", $$v)
              },
              expression: "keyData.bits"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pt-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-btn",
            {
              attrs: {
                loading: _vm.loading
              },
              on: {
                click: _vm.generate
              }
            },
            [_vm._v(" Generate Key Pair ")]
          )
        ],
        1
      ),
      _c("key-generated-modal", {
        attrs: {
          reason: _vm.reason,
          opened: _vm.resultModalOpened
        },
        on: {
          close: _vm.resultModalClosed
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }